<template>
  <div class="item" :class="{ 'item-hover': hasHover }" @click="onCourseClick">
    <ImageClip
      class="cover"
      :src="course.cover_img"
      :width="width"
      :height="height"
      :radius="8"
    ></ImageClip>
    <div class="body">
      <div class="title-wrap">
        <img
          class="tag"
          src="@/assets/images/common/lianbao@2x.png"
          v-if="course.is_discount == 1"
        />
        <img
          class="tag"
          src="@/assets/images/common/coupon@2x.png"
          v-if="course.is_has_coupon == 1 && course.price !== 0"
        />
        <img
          class="tag"
          src="@/assets/images/common/spell@2x.png"
          v-if="course.is_join_spell == 1"
        />
        <!-- <img
          class="tag tag-cert"
          src="@/assets/images/cert/tag@2x.png"
          v-if="course.is_has_cert == 1"
        /> -->
        <span
          class="title"
          :class="{
            'title-tag': course.is_has_coupon == 1 || course.is_join_spell == 1,
          }"
        >
          <span>{{ course.title }}</span>
        </span>
      </div>
      <!-- <div class="marketing_language">{{ course.marketing_language }}</div> -->
      <div class="teacher">
        <template v-if="teacher">
          <template v-if="course.teachers_list.length == 1">
            <div class="teacher">
              <img class="teacher-avatar" :src="teacher.teacher_avatar" />
              <div class="teacher-name">{{ teacher.teacher_name }}</div>
            </div>
          </template>
          <template v-else-if="course.teachers_list.length == 2">
            <div class="teacher">
              <img class="teacher-avatar" :src="course.teachers_list[0].teacher_avatar" />
            </div>
            <div class="teacher1 teacher">
              <img class="teacher-avatar" :src="course.teachers_list[1].teacher_avatar" />
            </div>
            <span class="teacher-name">2位讲师</span>
          </template>
          <template v-else>
            <div class="teacher">
              <img class="teacher-avatar" :src="course.teachers_list[0].teacher_avatar" />
            </div>
            <div class="teacher1 teacher">
              <img class="teacher-avatar" :src="course.teachers_list[1].teacher_avatar" />
            </div>
            <div class="teacher1 teacher" @click.stop>
              <img class="teacher-avatar" style="border: none" src="@/assets/images/more.png" />
            </div>
            <span class="teacher-name"> {{ course.teachers_list.length }}位讲师 </span>
          </template>
          <!-- <div
              class="teacher-num"
              v-if="course.teachers_list && course.teachers_list.length > 1"
            >
              共{{ course.teachers_list.length }}位讲师
            </div> -->
        </template>
      </div>
      <div class="course-footer">
        <div class="discount-wrap">
          <div class="course-sales">
            <template v-if="course.course_type != 3"> {{ saleNum }}人报名 </template>
            <template v-if="course.course_type == 3">
              {{ (course.browse_base || 0) + (course.browse_num || 0) }}人观看
            </template>
          </div>
        </div>

        <div class="right">
          <span class="discount" v-if="course.is_show_discount == 1">
            {{ course.discount }}折
          </span>
          <CurrencyNew
            :price="course.price"
            :priceUnderline="course.underlined_price"
            :priceTwo="true"
            v-if="course.has_buy == 0"
          ></CurrencyNew>
          <div class="has-buy" v-else>已报名</div>
        </div>
      </div>
    </div>
    <div
      v-if="course.course_type == 3 && course.play_type"
      class="state-wrap"
      :class="'state-wrap-' + state + ' play-type-' + course.play_type.play_type"
    >
      <span class="icon"></span>
      <span v-if="state == 0">{{ timeString }}开始</span>
      <span v-else-if="state == 1">直播中</span>
      <span v-else-if="state == -1">
        {{
          course.bjy_encode_status == 1
            ? '直播回放'
            : course.bjy_encode_status == 2
            ? '已结束(回放生成中)'
            : '已结束'
        }}
      </span>
    </div>
    <!-- 添加会员免费图标（除了公开课） -->
    <img
      v-if="
        (from == 'list' || from == 'index') &&
        !course.has_buy &&
        course.course_type !== 3 &&
        course.is_vip == 1 &&
        $store.state.commonSetting.switch_state == 1
      "
      class="is-vip"
      src="@/assets/images/course/vip-free@2x.png"
    />
  </div>
</template>
<script>
export default {
  name: 'RichCourseItem',
  props: {
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showTime: {
      type: Boolean,
      default: true,
    },
    hasHover: {
      type: Boolean,
      default: true,
    },
    width: {
      type: Number,
      default: 282,
    },
    height: {
      type: Number,
      default: 188,
    },
    withRecommend: {
      type: Boolean,
      default: true,
    },
    showPeriods: {
      type: Boolean,
      default: true,
    },
    from: {
      type: String,
      default: 'list',
    },
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    teacher() {
      return (this.course.teachers_list || [])[0];
    },
    state() {
      if (this.course.course_type != 3) {
        return '';
      }
      let tsNow = parseInt(new Date().getTime() / 1000);
      if (tsNow < this.course.start_play_date) {
        return 0;
      } else if (tsNow >= this.course.start_play_date && tsNow <= this.course.end_play_date) {
        return 1;
      }
      return -1;
    },
    timeString() {
      if (this.course.course_type != 3) {
        return '';
      }
      let ts = this.course.start_play_date;
      let date = new Date(ts * 1000);
      let dateNow = new Date();
      if (date.getFullYear() > dateNow.getFullYear()) {
        return date.format('yyyy-MM-dd hh:mm');
      }
      if (date.format('yyyy-MM-dd') == dateNow.format('yyyy-MM-dd')) {
        let tsSurplus = ts - parseInt(dateNow.getTime() / 1000);
        if (tsSurplus > 30 * 60) {
          return date.format('hh:mm');
        }
        return parseInt(tsSurplus / 60) + '分钟后';
      }
      dateNow.setDate(dateNow.getDate() + 1);
      if (date.format('yyyy-MM-dd') == dateNow.format('yyyy-MM-dd')) {
        return '明天' + date.format('hh:mm');
      }
      dateNow.setDate(dateNow.getDate() + 2);
      if (date.format('yyyy-MM-dd') == dateNow.format('yyyy-MM-dd')) {
        return '后天' + date.format('hh:mm');
      }
      return date.format('MM-dd hh:mm');
    },
    saleNum() {
      if (!this.course.id) return 0;
      if (this.from == 'list') {
        return this.course.sales_num;
      }
      if (this.course.sales_base) {
        return this.course.sales_num + this.course.sales_base;
      }
      return this.course.sales_num;
    },
  },
  data() {
    return {
      course_type_name: '',
    };
  },
  watch: {
    commonSetting() {
      this.init();
    },
    course() {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.commonSetting.course_name) {
        return;
      }
      this.course_type_name = this.commonSetting.course_name[this.course.course_type];
    },
    onCourseClick() {
      let route = '';
      if (this.$route.path == '/course/classify') {
        route = 'CourseListClassifyShow';
      } else if (this.$route.path == '/course/type') {
        route = 'CourseListTypeShow';
      } else {
        route = 'CourseShow';
      }
      let query = {
        nav: this.$route.query.nav,
      };
      if (this.withRecommend) {
        query.title = this.$route.query.title;
        query.recommend = this.$route.query.recommend;
      }
      if (this.course.course_type == 3) {
        query.title = '公开课';
      }
      this.$router.push({
        name: route,
        params: {
          id: this.course.id,
        },
        query: query,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  width: 282px;
  height: 328px;
  box-sizing: border-box;
  overflow: hidden;
  float: left;
  margin-right: 24px;
  cursor: pointer;
  background: white;
  // border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 8px;
  position: relative;
  margin-bottom: 24px;

  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);

    .cover {
      ::v-deep {
        img {
          transform: scale(1.1);
        }
      }
    }
  }

  &:nth-child(4n) {
    margin-right: 0;
  }
}

.cover {
  margin-bottom: 17px;
  border-radius: 8px 8px 0 0 !important;

  ::v-deep {
    img {
      transform: scale(1);
      transition: all 0.5s;
    }
  }
}

.title-wrap {
  height: 50px;
  overflow: hidden;
  // margin-bottom: 13px;
}

.tag {
  height: 18px;
  vertical-align: -3px;
  margin-right: 5px;
}

.title-tag {
  margin-left: 2px;
}

.marketing_language {
  height: 17px;
  font-size: 16px;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.is-vip {
  width: 60px;
  position: absolute;
  top: 0;
  right: 0;
}

.body {
  padding: 0 16px 19px 16px;
}

.title {
  font-size: 14px;
  color: rgba(32, 36, 42, 1);
  line-height: 14px;
  font-weight: 600;
}

.course-schedule {
  display: flex;
  align-items: center;
  margin-bottom: 9px;
}
.teacher {
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  // bottom: 50px;
}
.teacher1 {
  margin-left: -10px;
}

.teacher-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: block;
  margin: 0 auto 0px auto;
  border: 1px solid #fff;
  box-sizing: border-box;
}

.teacher-name {
  margin-left: 8px;
  height: 14px;
  font-size: 13px;
  color: #333;
  line-height: 1;
  max-width: 106px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  // margin-top: -5px;
}

.teacher-num {
  position: absolute;
  height: 23px;
  background: rgba($primary-color, 0.08);
  white-space: nowrap;
  line-height: 23px;
  padding: 0 14px 0 10px;
  font-size: 13px;
  color: $primary-color;
  border-radius: 11px 11px 11px 0;
  top: -11px;
  left: 50%;
  margin-left: 17px;
}
.course-footer {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  left: 0;
  bottom: 16px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  height: 22px;

  .right {
    display: flex;
    flex-direction: row;
    text-align: right;
    // float: right;
    position: absolute;
    right: 16px;
  }

  .course-periods {
    height: 14px;
    font-size: 14px;
    color: #999999;
    line-height: 1;
    margin-bottom: 10px;
  }

  .course-sales {
    height: 13px;
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    line-height: 22px;
    height: 22px;
  }

  ::v-deep {
    .price-wrap {
      margin-bottom: 3px;
      .price-underline {
        margin-right: 8px;
      }
    }
  }

  .discount-wrap {
    // flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
    float: left;

    height: 22px;
  }

  .discount {
    flex-shrink: 0;
    font-size: 12px;
    line-height: 1;
    color: #73501d;
    background: rgba(252, 237, 206, 0);
    border-radius: 4px;
    padding: 5px 6px;
    position: relative;
    display: inline-block;
    text-align: center;
    background: linear-gradient(to right, #f4dda8, #f4c56c);
    margin-right: 10px;
    // &::after {
    //   content: "";
    //   position: absolute;
    //   width: 0;
    //   height: 0;
    //   border: 6px solid transparent;
    //   border-left-color: #f4c56c;
    //   right: -12px;
    //   top: 50%;
    //   transform: translateY(-50%);
    // }
    &::before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border: 4px solid transparent;
      border-left-color: #f4c56c;
      right: -8px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 9;
    }
  }
}
.has-buy {
  font-size: 16px;
  color: $primary-color;
  font-weight: 600;
}
.state-wrap {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 26px;
  line-height: 26px;
  border-radius: 6px 0px 10px 0px;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: white;
}
.state-wrap-0 {
  background: $primary-color;
  padding: 0 8px;
}
.state-wrap-1 {
  background: #ff2424;
  padding: 0 8px;

  .icon {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    background-image: url('~@/assets/images/course/live.gif');
    background-size: 100% 100%;
  }
}
.state-wrap--1 {
  background: rgba(0, 0, 0, 0.5);
  padding: 0 8px;
  &.play-type-0 {
    .icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      background-image: url('~@/assets/images/course/play.png');
      background-size: 100% 100%;
    }
  }
  &.play-type-4 {
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 6px;
      background-image: url('~@/assets/images/course/play@2x.png');
      background-size: 100% 100%;
    }
  }

  &.play-type-5,
  &.play-type-3 {
    background: rgba(0, 0, 0, 0.5);

    .icon {
      width: 16px;
      height: 16px;
      margin-right: 6px;
      background-image: url('~@/assets/images/course/live-none@2x.png');
      background-size: 100% 100%;
    }
  }
}
</style>
